import PropTypes from 'prop-types'
import axios from 'axios'
export default function RegisterAPI ( props ) {
    const { apiUrl, email,
        mobilePhoneNumber, password,
        firstName, lastName, confirmEmail,acceptTerms } = props
    
    const formData  = new FormData()    
    formData.append( 'email', email )
    formData.append( 'confirmEmail', confirmEmail )
    formData.append( 'mobilePhoneNumber', mobilePhoneNumber )
    formData.append( 'password', password )
    formData.append( 'confirmPassword', password )
    formData.append( 'firstName', firstName )
    formData.append( 'lastName', lastName )
    formData.append( 'acceptTerms', acceptTerms )
    formData.append( 'webId', 'autogenerated' )
    formData.append( 'type', '' )
    formData.append( 'returnurl', '' )
    
    return axios.post( apiUrl, formData )            
        .then( response => {
            return !response.data  ? null : response.data
        } )
        .catch( e => {
            return null
        } )
}
RegisterAPI.propTypes = {
    apiUrl: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    confirmEmail: PropTypes.string.isRequired,
    mobilePhoneNumber: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    acceptTerms: PropTypes.bool.isRequired,
}